<template>
  <a-drawer
    title="分发记录"
    width="700"
    :visible="visible"
    :closable="false"
    :footer="false"
    @close="onClose"
  >
    <!-- 列表 -->
    <a-table
      class="table-view"
      :data-source="dataSource"
      :columns="columns"
      :row-key="record => record.id"
      :pagination="pagination"
      :loading="isLoading"
      @change="handleTableChange"
    >
      <!-- 自定义行内容 -->
      <template #bodyCell="{ column, record }">
        <!-- 界面语种 -->
        <template v-if="column.key === 'lang_name'">
          {{ record.lang.lang_name }}
        </template>
      </template>
    </a-table>
  </a-drawer>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { distributeList } from '@/api/admin'

// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 片库id
let dramaID = ref(undefined)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '界面语种',
    dataIndex: 'lang_name',
    key: 'lang_name'
  },
  {
    title: '分发日期',
    dataIndex: 'distribution_date',
    key: 'distribution_date'
  },
])

// 显示
function showDrawer (data) {
  // 显示
  visible.value = true
  // 片库id
  dramaID.value = data.id
  // 获取分发记录列表
  getDistributeList()
}

// 分发记录
function getDistributeList () {
  isLoading.value = true
  distributeList({
    drama_id: dramaID.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    }
  }).catch(() => {
    isLoading.value = false
  })
}

// 关闭
function onClose () {
  if (!isLoading.value) {
    // 重置
    pagination.current = 1
    pagination.pageSize = 10
    visible.value = false
  }
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getDistributeList()
}

// 抛出
defineExpose({
  showDrawer
})

</script>

<style scoped>
.ant-btn-link {
  padding: 0;
}
</style>